import { Box, Skeleton } from '@mui/material';

type KpiLoaderProps = {
    isTrailLoader: boolean;
};

const KpiLoader = ({ isTrailLoader }: KpiLoaderProps) => {
    const loaderContainerHeight = isTrailLoader ? 240 : 228;
    const loaderLeftSectionDesktopWidth = isTrailLoader ? '48.8%' : '24.4%';
    const loaderRightSectionDesktopWidth = `calc(100% - ${loaderLeftSectionDesktopWidth} - 15px)`;
    const loaderRightSectionHeight = isTrailLoader ? '208px' : '196px';
    const loaderCardsCount = isTrailLoader ? 3 : 2;
    const loaderStatusColumns = isTrailLoader ? '1fr' : '1fr 1fr';
    const loaderStatusItemsCount = isTrailLoader ? 5 : 10;

    return (
        <Box
            sx={{
                width: '100%',
                mt: 2,
                mb: 2,
                height: loaderContainerHeight,
                boxSizing: 'border-box',
                display: 'flex',
                gap: '15px',
                alignItems: 'stretch',
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                borderRadius: '8px',
                opacity: 1,
                p: '16px',
                background: '#E9E9E9',
                boxShadow: '1px 1px 7.1px 0px #00000040',
            }}
        >
            <Box
                sx={{
                    width: { xs: '100%', md: loaderLeftSectionDesktopWidth },
                    maxWidth: { xs: '100%', md: loaderLeftSectionDesktopWidth },
                    flex: { xs: '1 1 100%', md: `0 0 ${loaderLeftSectionDesktopWidth}` },
                    height: '100%',
                    display: 'grid',
                    gridTemplateColumns: isTrailLoader ? '1fr 1fr' : '1fr',
                    gridTemplateRows: isTrailLoader ? 'repeat(2, minmax(0, 1fr))' : `repeat(${loaderCardsCount}, minmax(0, 1fr))`,
                    columnGap: isTrailLoader ? '15px' : '0px',
                    rowGap: '15px',
                }}
            >
                {Array.from({ length: loaderCardsCount }).map((_, index) => (
                    <Skeleton
                        key={`kpi-summary-loader-${index}`}
                        animation="wave"
                        variant="rounded"
                        sx={{
                            height: '100%',
                            borderRadius: '8px',
                            gridColumn: isTrailLoader && index === 2 ? '1 / 2' : 'auto',
                        }}
                    />
                ))}
            </Box>

            <Box
                sx={{
                    width: { xs: '100%', md: loaderRightSectionDesktopWidth },
                    maxWidth: { xs: '100%', md: loaderRightSectionDesktopWidth },
                    flex: { xs: '1 1 100%', md: `0 0 ${loaderRightSectionDesktopWidth}` },
                    height: loaderRightSectionHeight,
                    borderRadius: '8px',
                    background: '#FFFFFF',
                    boxShadow: '1px 2px 7.1px 0px #00000040',
                    pr: '38px',
                    pl: '38px',
                    py: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: '15px', lg: '42px' },
                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                }}
            >
                <Skeleton animation="wave" variant="circular" width={164} height={164} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Skeleton animation="wave" variant="text" width="52%" height={32} sx={{ mb: 0.8 }} />
                    <Box sx={{ display: 'grid', gridTemplateColumns: loaderStatusColumns, columnGap: { xs: '10px', md: '30px' }, rowGap: '8px' }}>
                        {Array.from({ length: loaderStatusItemsCount }).map((_, index) => (
                            <Skeleton key={`kpi-status-loader-${index}`} animation="wave" variant="rounded" height={16} />
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default KpiLoader;
